import '../../boot'
import './index.scss'
import { createApp, ref } from 'vue/dist/vue.esm-bundler'
import AppLayoutMixin from '../../app-layout-mixin'
import { NButton, NFormItem, NForm, NCard, NSpace, NInputNumber, NTable, NThead, NTbody, NTh, NTr, NTd } from 'naive-ui'
import EmbedCode from "@/components/embed";
import { GChart } from 'vue-google-charts'


createApp({
    components: { NButton, NFormItem, NForm, NCard, NSpace, NInputNumber, NTable, NThead, NTbody, NTh, NTr, NTd, EmbedCode, GChart },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            monthly: 100,
            returns: 12,
            period: 5,
            chartOptions: {
                height: 350,
                legend: {
                    position: 'bottom',
                    textStyle : {
                        color: '#888',
                    }
                },
                hAxis: {
                    title: 'Years'
                },
                curveType: 'function',
                chartArea:{
                    left: 50,
                    right: 50,
                    top: 20,
                    bottom: 70,
                },
            }
        }
    },
    computed: {
        totalInvested() {
            return this.investedForPeriod(this.period);
        },
        totalReturns() {
            return this.totalAmount - this.totalInvested;
        },
        totalAmount() {
            return this.amountForPeriod(this.period);
        },
        totalRor() {
            return Math.round(this.totalReturns/this.totalInvested*10000)/100;
        },
        chartData() {
            const data = [
                ['Years', 'Total invested', 'Returns', 'Total']
            ];

            for (let i = 1; i <= this.period; i++) {
                const invested = this.investedForPeriod(i);
                const total = this.amountForPeriod(i);
                data.push([
                    i,
                    invested,
                    total - invested,
                    total,
                ]);
            }

            return data;
        }
    },
    methods: {
        formatNumber(x) {
            return Math.floor(x * 100)/100;
        },
        investedForPeriod(period) {
          return this.monthly * 12 * period;
        },
        amountForPeriod(period) {
            const monthlyReturn = this.returns / 12 / 100;
            return Math.round(this.monthly * ( Math.pow(1+monthlyReturn, 12*period) - 1) * (1 + monthlyReturn) / monthlyReturn);
        }
    }
}).mount('#app')
